import React, {Fragment, useState} from "react";
import BorderBox from "./BorderBox";
import GroupHeaderItem from "./GroupHeaderItem";
import ChoiceList from "./ChoiceList";
import {Layers, LayerTitles} from "./Layers";
import {currency} from "./Helper";
import FileDropZone, {ValidateImage} from "../components/FileDropZone";

const groupEditor = {
    'size': SimpleChoiceList,
    'flavor': SimpleChoiceList,
    'finish': SimpleChoiceList,
    'decor': DecorChoiceList
}

function SimpleChoiceList({group, cake, config, updateCake}) {
    return <ChoiceList group={group} choices={config.groups[group].map((tag) => config.items[tag])} value={cake[group]} config={config} onChange={(value) => {
        updateCake(group, value);
    }} />;
}

function DecorChoiceList({group, cake, config, updateCake}) {

    const customizer = cake[group] ? config.items[cake[group]].customizer : null;

    return <Fragment>
        <ChoiceList group={group} choices={config.groups[group].map((tag) => config.items[tag])} value={cake[group]} config={config} onChange={(value) => {
            updateCake(group, value);
            updateCake('customizer', Object.assign({type: 'none', 'text': '', 'image': false }, cake.customizer, { type: value }));
        }} />
        {customizer && <Customizer type={customizer} group={group} cake={cake} config={config} updateCake={updateCake} />}
    </Fragment>;
}

function Customizer(props) {
    const type = props.type;

    const updateCustomizer = (value) => {
        const currentCustomizer = props.cake.customizer ? props.cake.customizer : {};
        currentCustomizer[type] = value;
        currentCustomizer.type = type;

        props.updateCake('customizer', currentCustomizer);
    };

    switch (type) {
        case 'image':
            return <ImageCustomizer {...props} updateCake={updateCustomizer} />;
        case 'text':
            return <TextCustomizer {...props} updateCake={updateCustomizer} />;
    }
    return null;
}

function TextCustomizer({cake, updateCake}) {
    return <div className={"hg-cake-customizer hg-cake-customizer--text"}>
        <h2>Ihr Text</h2>
        <textarea rows={"2"} maxLength={"30"} onChange={(e) => updateCake(e.target.value)} />
        <span className={"info-message"}>
            Maximal 30 Zeichen
        </span>
    </div>
}

function ImageCustomizer({cake, config, updateCake}) {
    const hasFile = cake.customizer && cake.customizer.image;

    return <div className={"hg-cake-customizer hg-cake-customizer--image"}>
        <h2>Ihr Bild</h2>
        <div className={"hg-cake-customizer__controls"}>
            <FileDropZone
                validateFile={ValidateImage}
                idle={<span>Hier klicken, oder Datei ins Feld ziehen</span>}
                hot={<span>Jetzt loslassen!</span>}
                handleFiles={updateCake}>
                {hasFile && <img src={cake.customizer.image} />}
            </FileDropZone>

            <div className={"hg-cake-customizer--imageinfo info-message"} dangerouslySetInnerHTML={{__html: config.help.image }} />
        </div>
    </div>
}

export function CakeChoiceSummary(cake, config) {
    return ({group}) => {
        if (cake[group]) {
            const item = config.items[cake[group]];

            let name = item.name;
            if (item.parent) {
                name = config.items[item.parent].name + ' ' + name;
            }

            return <div className={"hg-cake-choice-itemsummary"}>
                <div className={"hg-cake-choice-itemsummary__name"}>
                    {name}
                    {group === 'size' && item.description && <div>{item.description}</div>}
                </div>
                <div className={"hg-cake-choice-itemsummary__price"}>{currency(config.items[cake[group]].price)}</div>
            </div>;
        }
        return null;
    }
}

function CakeLoading() {
    return <div className={"hg-cake-loading"}>
        <h2>Ihre Torte wird bearbeitet.</h2>
    </div>
}

export default function HgCakeChoices({isLoading, isDirty, setCurrentGroup, currentGroup, config, cake, updateCake}) {

    const setLayers = Layers.reduce((c, group) => {
        if (cake[group]) {
            return c + 1;
        }
        return c;
    }, 0);

    const EditorComponent = currentGroup ? groupEditor[currentGroup] : false;

    const [found, next] = Layers.reduce(([ found, next], group) => {
        if (group === currentGroup) {
            return [
                true, next
            ];
        }
        if (found) {
            return [
                false, group
            ]
        }

        return [found, next];
    }, [false, ''])

    return <div className={"hg-cake-editor-choices"}>
        <BorderBox>
            <div className={"hg-tabbed-border__header"}>
                {Layers.map((group, idx) => {
                    const enabledGroup = idx <= setLayers;

                    return <GroupHeaderItem key={group}
                                            group={group}
                                            currentGroup={currentGroup}
                                            onSelected={setCurrentGroup}
                                            enabled={enabledGroup}>
                    </GroupHeaderItem>
                })}
            </div>
            {!isLoading && EditorComponent && <EditorComponent group={currentGroup} isLoading={isLoading} updateCake={updateCake} config={config} cake={cake} />}
            {isLoading && <CakeLoading />}

            {!isLoading && next !== '' && <div className={"hg-cake-editor-choices-navi"}>
                <span className={"hg-button"}>
                    <button disabled={!cake[currentGroup]} onClick={(e) => setCurrentGroup(next)}>Weiter</button>
                </span>
            </div>}
        </BorderBox>
    </div>;
}


// WEBPACK FOOTER //
// ./js/cake/HgCakeChoices.js